import {useEffect, useMemo, useState} from "react";
import {useLazySearchUsersQuery} from "../api/userDirectoryApi";

// Hook גלובלי: debounce על שאילתת חיפוש משתמשים + חשיפת תוצאות/מצב טעינה.
// זיהוי ספרות-מול-טקסט מתבצע בצד השרת (ראו learning/api_views_user_directory.py).
export function useUserSearch(debounceMs = 300) {
    const [term, setTerm] = useState("");
    const [trigger, {data, isFetching}] = useLazySearchUsersQuery();

    useEffect(() => {
        const q = term.trim();
        if (!q) return;
        const handle = setTimeout(() => {
            trigger(q);
        }, debounceMs);
        return () => clearTimeout(handle);
    }, [term, trigger, debounceMs]);

    const results = useMemo(() => data ?? [], [data]);

    return {term, setTerm, results, isFetching};
}
